export default __webpack_public_path__ + "static/media/photo--lg--kara12.bd1edea7.jpg";